













































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { authorClient } from "@/api/index";
import { errorMsg, setCommon } from "@/utils/request";
import { arrRemove, timeFormat } from "@/utils/index";
@Component({
  name: "system",
})
export default class UserManagement extends Vue {
  @Provide() private addPermForm: any = {
     permId: '',
     resourceIds: '',
     bindingid: ''
  }; // 添加权限form
  @Provide() private rules:any = {
    permId: [
      { required: true, message: '请选择按钮', trigger: 'change' }
    ],
    resourceIds: [
      { required: true, message: '请选择路由', trigger: 'change' }
    ],
  };
  @Provide() private dialogAddPermVisible: boolean = false; // 添加权限弹窗
  @Provide() private pageData: any = []; // 页面修改详情
  @Provide() private buttonData: any = []; // 按钮修改详情
  @Provide() private authorityData: any = []; // 权限修改详情
  @Provide() private dataList: any =[]; // page列表
  @Provide() private defaultProps:any = { children: 'kidsList', label: 'name', id: 'permtype', index: 'index', edit: 'edit', permtype: 'permtype', ext:'ext' };
  @Provide() private addType: string = "button";
  @Provide() private first: boolean = true; // 第一组button
  @Provide() private permid: string = ""; // pageid
  @Provide() private filterPage: string = ""; // page搜索输入
  @Provide() private routeData: any = []; // 路由列表
  @Provide() private expandedKeys: any = []; // 自动展开数组项
  @Provide() private flag: boolean = true; // 创建一级菜单时，刷新该条数据
  @Provide() private permType:number = 0; // 权限操作类型1：编辑，2：添加


  // @Provide() private data:any = [];
  @Provide() private drag: any = {
    id:-1,
    parentPermId: -1,
    childNode: "",
    parentNode: ""
  }; // 拖拽进入点对应的父级id(新的父级别ID，如果没有修改层级，传-1)
  private created() {
    this.getRouteTree();
    this.first = true;
  }
  private handleDragStart(node:any, ev:any) {
     this.drag.id = node.key;
     this.drag.childNode = node.label;
  };
  private handleDragEnter(draggingNode:any, dropNode:any, ev:any) {
    this.drag.parentPermId = dropNode.key;
    this.drag.parentNode = dropNode.label;
  };
  private handleDragLeave(draggingNode:any, dropNode:any, ev:any) {
  };
  private handleDragOver(draggingNode:any, dropNode:any, ev:any) {
  };
  private handleDragEnd(draggingNode:any, dropNode:any, dropType:any, ev:any) {
    this.$confirm(`确认将 "${this.drag.childNode}" 移入 "${this.drag.parentNode}" ?`, '', {
      confirmButtonText: '确定',
      cancelButtonText: '取消'
    }).then(() => {
      this.updatePageAPI(this.drag,null, true)
    }).catch(() => {
      this.getRouteTree();
      this.first = true;
    });
  };
  private handleDrop(draggingNode:any, dropNode:any, dropType:any, ev:any) {
  };
  private allowDrop(draggingNode:any, dropNode:any, type:any) {
    return true;
  };
  private allowDrag(draggingNode:any) {
    return true;
  };
  @Watch("filterPage")
  onFilterPageChanged(val: string) {
    const ref: any = this.$refs.tree;
    ref.filter(val);
  }

  private filterNode(value: string, data: any) {
    if (!value) return true;
    return data.name.indexOf(value) !== -1;
  }
  // 查询路由，不分页，可模糊查询
  private async searchRouteRequest() {
    let otp = {
      name: "",
      pageIndex: 1,
      pageSize: 1000
    }
    const { listRouter }: any = await import(
      "@/request/getrouterList"
    );
    let res = await listRouter(otp, this);
    if (res) {
      this.routeData = res.resourcelistList;
    }
  }
  // 展示button列表
  private showButton (data:any) {
    this.permid = data.id;
    this.expandedKeys.push(data.permid);
    this.getPermAPI();
    this.buttonData = data.button || [];
    this.buttonData.map((item:any, index:number)=>{
      this.buttonData[index].operatortime = item.ext.operatortime > 0 && timeFormat(item.ext.operatortime);
      this.buttonData[index].operator = item.ext.operator;
    })
    this.pageData = [];
    this.pageData.push({
      "pagename": data.name,
      "menuid": data.ext.menuid, // 2021-04-29 有data.id转为data.ext.menuid
      "operatetime":data.ext.operatortime > 0 && timeFormat(data.ext.operatortime),
      "operator": data.ext.operator }
    );
    this.resetFields('addPermForm');
  };
  // 添加按钮弹窗
  private addButton (){
    this.$prompt('', '添加按钮', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputPlaceholder: "请输入按钮名称"
    }).then((value) => {
      let data = {id:this.permid,type:2}
      this.createPageAPI(value, data);
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '取消输入'
      });
    });
  }
  // 添加权限弹窗
  private addPerm (apiType:number, data?:any){
    // apiType 1：编辑权限，2:添加权限
    this.dialogAddPermVisible = true;
    if(apiType === 1){
      this.addPermForm  = {
        permId: data.permid,
        resourceIds: data.id,
        bindingid: data.bindingid
      };
    } else {
      this.addPermForm  = {
        permId: '',
        resourceIds: '',
        bindingid: ''
      };
      this.resetFields('addPermForm');
    }
    this.permType = apiType;
    this.searchRouteRequest();
  }
  // 权限提交验证
  private submitPerm(formName:string){
    let ref: any = this.$refs[formName];
    ref.validate((valid:any) => {
      if (valid) {
        this.permType === 1 ? this.updatePermAPI() : this.addPermAPI();
      } else {
        return false;
      }
    });
  }
  // 编辑权限
  private async updatePermAPI(){
    let otp = {
      permid: this.addPermForm.permId,
      resourceId: this.addPermForm.resourceIds,
      bindingid: this.addPermForm.bindingid
    }
    const { updatePerm }: any = await import(
      "@/request/pageTree"
    );
    let res = await updatePerm(otp, this);
    if (res.code === 0) {
      this.$message({
        message: '添加成功',
        type: 'success'
      });
      this.getRouteTree(this.addPermForm.permId);
      this.dialogAddPermVisible = false;
      this.resetFields('addPermForm');
    }
  }
  // 添加权限
  private async addPermAPI(){
    let resourceId = this.addPermForm.resourceIds;
    let otp = {
      permid: this.addPermForm.permId,
      resourceIds: [resourceId]
    }
    const { createPerm }: any = await import(
      "@/request/pageTree"
    );
    let res = await createPerm(otp, this);
    if (res.code === 0) {
      this.$message({
        message: '添加成功',
        type: 'success'
      });
      this.getRouteTree(this.addPermForm.permId);
      this.dialogAddPermVisible = false;
      this.resetFields('addPermForm');
    }
  }
  // 重置 输入权限内容
  private resetFields(form:string){
    let ref: any = this.$refs[form];
      if (ref) {
        ref.resetFields();
      }
  }
  // 删除权限
  private async deletePermAPI(data:any){
    let otp = {
      permid: data.permid,
      resourceId: data.id
    }
    const { deletePerm }: any = await import(
      "@/request/pageTree"
    );
    let res = await deletePerm(otp, this);
    if (res.code === 0) {
      this.$message({
        message: '添加成功',
        type: 'success'
      });
      this.getRouteTree(this.permid);
    }
  }
  // 被选中的标签 tab
  handleClick(tab:any) {
    this.addType = tab.name;
  }
  // 修改、添加page弹窗
  private update(data:any, apiType:number){
    // apiType 1：编辑页面，2:编辑按钮,3：添加， 4：添加一级page
    let inputValue = apiType <= 2 ? data.name : '';
    let title = apiType <= 2 ? '编辑' : '添加';
    data = apiType === 4 ? {id:0}: data;
    data.type = apiType > 2 ? 1 : null;
    this.$prompt('', title, {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputPlaceholder: "请输入名称",
      inputValue: inputValue
    }).then((value) => {
      apiType <= 2 ? this.updatePageAPI(data,value,false, apiType) : this.createPageAPI(value, data);
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '取消输入'
      });
    });
  }
  // 2021-04-28 lee 添加page弹窗
  private addNewPage(data:any, apiType:number) {
    // apiType 3：添加， 4：添加一级page
    let inputPageName = '';  // 页面名称
    let inputPageId = '';  // 页面id
    const title = '添加';
    data = apiType === 4 ? { id: 0 } : data;
    data.type = 1;
    const h = this.$createElement;
    this.$msgbox({
      title,
      message: h('div', {
      }, [
        h('input', {
          attrs: {
            class: 'msgbox-input',
            type: 'text',
            placeholder: '请输入页面名称',
            id: 'myMsgBoxPageNameRef',
            target: '#box',
          },
          domProps: {
            value: ''
          }
        }),
        h('input', {
          attrs: {
            class: 'msgbox-input',
            type: 'number',
            placeholder: '请输入页面ID',
            id: 'myMsgBoxPageIDRef'
          },
          domProps: {
            value: ''
          }
        })
      ]),
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          setTimeout(() => {
            done();
            setTimeout(() => {
              instance.confirmButtonLoading = false;
            }, 300);
          }, 3000);
        } else {
          done();
        }
      }
    }).then((value) => {
      if(value === 'confirm') {
        const MyMsgBoxPageNameRef = document.getElementById('myMsgBoxPageNameRef'),
              MyMsgBoxPageIDRef = document.getElementById('myMsgBoxPageIDRef');
        this.createPageAPI({
          value: (MyMsgBoxPageNameRef as any).value,
          SpecifiedMenuId: +(MyMsgBoxPageIDRef as any).value
        }, data);
      }else{
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      }
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '取消输入'
      });
    });;
  }
  //修改page
  private async updatePageAPI(data:any,value?:any, levelChange?:boolean, type?:number){
    let otp = {
      permid: data.id,
      parentPermId: levelChange ? data.parentPermId : -1,
      name: value? value.value : ""
    }
    const { updatePage }: any = await import(
      "@/request/pageTree"
    );
    let res = await updatePage(otp, this);
    if (res.code === 0) {
      this.$message({
        message: '修改成功',
        type: 'success'
      });
      let id = type === 2 ? data.pid : data.id;
      this.getRouteTree(id);
    }
  }
  //添加page、按钮
  private async createPageAPI(param: any, data: any){
    let otp = {
      parentPermId: data.id,
      name: param.value,
      type: data.type ? data.type : null
    }
    if(param.SpecifiedMenuId) {
      (otp as any).specifiedMenuId = param.SpecifiedMenuId
    }
    const { createPage }: any = await import(
      "@/request/pageTree"
    );
    let res = await createPage(otp, this);
    if (res.code === 0) {
      this.$message({
        message: '添加成功',
        type: 'success'
      });
      this.getRouteTree(data.id);
    }
  }
  // 删除Page,按钮确认弹窗
  private remove(data:any, type:number) {
    this.$confirm(this.$tc('authority.confirmDelete'), '', {
      confirmButtonText: '确定',
      cancelButtonText: '取消'
    }).then(() => {
      type === 1 ? this.deletePageAPI(data) : this.deletePermAPI(data);
    }).catch(() => {
    });
  }
  // 删除Page
  private async deletePageAPI(data: any) {
    let otp = {
      permid: data.id
    }
    const { deletePage }: any = await import(
      "@/request/pageTree"
    );
    let res = await deletePage(otp, this);
    if (res.code === 0) {
      this.$message({
        message: '删除成功',
        type: 'success'
      });
      // 如果删除一级页面，则默认显示列表第一项
      let id = data.pid > 0 ? data.pid : this.first= true;
      this.getRouteTree(data.pid);
    }
  }
  // 获取菜单树
  private async getRouteTree(openIds?:string) {
    const { getPageTree }: any = await import(
      "@/request/pageTree"
    );
    let res = await getPageTree("", this);
    if (res) {
      this.flag = true;
      this.dataList = this.getRouteTreeFunc(res.treeList, 1, "", openIds);
    }
  }
  // 菜单数据调整
  private getRouteTreeFunc(tree: any, index: number, parentId?:string|number, openIds?:string|number) {
    tree.forEach((item: any) => {
      if (item.kidsList && item.kidsList.length) {
        let tempIndex = index;
        // 判断子元素是否为子页面，子页面继续递归 ，如果是button，将子元素复制给button，并将其置为空
        if(+item.kidsList[0].ext.permtype === 1) {
          this.getRouteTreeFunc(item.kidsList, ++tempIndex, item.id, openIds);
        } else {
          let arr: any = [];
          [arr, item.kidsList] = [item.kidsList, arr];
          item.button = arr;
          // 读取第一组button
          if(this.first){
            this.permid = item.id;
            this.showButton(item);
            this.first = false;
          }
        }
      }
      if (openIds == item.id){
        this.showButton(item);
        this.expandedKeys.push(this.permid);
      } else if(openIds == 0 && this.flag){
        this.flag = false;
      } else {
        item.button && item.button.forEach((i: any) => {
          if (openIds == i.id){
            this.showButton(item);
            this.expandedKeys.push(this.permid);
          }
        })
      }
    });
    return tree;
  }
  //获取权限
  private async getPermAPI (){
    if(this.addType == "button") return;
    let otp = {
      permid: this.permid
    }
    const { getPerm }: any = await import(
      "@/request/pageTree"
    );
    let res = await getPerm(otp, this);
    if (res) {
      this.authorityData = this.getPermFunc(res.resourcelistList);
    }
  }
  // 权限数据调整
  private getPermFunc (data:any){
    data.forEach((item: any) => {
      item.operatortime = item.operatortime > 0 ? timeFormat(item.operatortime) : "";
    });
    return data;
  }
}
